import { useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

const BASE_URL = "https://platform-api.tribemails.com";
const CACHE_EXPIRY = 5 * 60 * 1000;  // 5 minutes

// ✅ Firebase token cache (avoids re-fetching the token on every request)
let firebaseToken = null;

// ✅ Function-based API Fetch (can be used anywhere)
export const authFetch = async ({ apiMethod, endpoint, onDataLoaded, onErrorResponse, headers = {}, body = null, queryParams = {} }) => {
    try {
        // ✅ Ensure Firebase authentication
        const auth = getAuth();
        const currentUser = auth.currentUser;
        if (!currentUser) throw new Error("User not logged in");

        // ✅ Get Firebase ID token, cache for efficiency
        if (!firebaseToken) {
            firebaseToken = await currentUser.getIdToken();
        }

        // ✅ Build URL with query parameters
        const queryString = new URLSearchParams(queryParams).toString();
        const fullUrl = `${BASE_URL}${endpoint}${queryString ? `?${queryString}` : ""}`;

        // ✅ Implement caching logic for GET requests
        // if (apiMethod === "GET" && !queryString) {
        //     const cacheKey = `fetch_${endpoint}`;
        //     const cachedData = sessionStorage.getItem(cacheKey);
        //     const cacheTimestamp = sessionStorage.getItem(`${cacheKey}_timestamp`);

        //     if (cachedData && cacheTimestamp && (Date.now() - parseInt(cacheTimestamp, 10) < CACHE_EXPIRY)) {
        //         console.log(`✅ Using cached data for ${fullUrl}`);
        //         onDataLoaded && onDataLoaded(JSON.parse(cachedData));
        //         return JSON.parse(cachedData);
        //     }
        // }

        console.log(`⏳ Fetching new data for ${fullUrl}`);

        // ✅ Prepare request headers
        const requestHeaders = {
            "Authorization": `Bearer ${firebaseToken}`,
            "Content-Type": "application/json",
            ...headers,
        };

        const requestOptions = {
            method: apiMethod,
            headers: requestHeaders,
            ...(body ? { body: JSON.stringify(body) } : {}),
        };

        // ✅ Fetch data
        const cacheKey = `fetch_${endpoint}`;
        const response = await fetch(fullUrl, requestOptions);
        if (!response.ok) throw new Error(`Error ${response.status}: ${response.statusText}`);

        const result = await response.json();
        onDataLoaded && onDataLoaded(result);

        // ✅ Cache GET responses
        // if (apiMethod === "GET" && !queryString) {
        //     sessionStorage.setItem(`fetch_${endpoint}`, JSON.stringify(result));
        //     sessionStorage.setItem(`${cacheKey}_timestamp`, Date.now().toString());
        // }

        return result;
    } catch (error) {
        console.error("Error fetching data:", error);
        onErrorResponse && onErrorResponse(error);
        throw error;
    }
};

// ✅ React Component for Auth Fetch
export const AuthFetch = ({ apiMethod, endpoint, onDataLoaded, onErrorResponse, headers = {}, body = null, queryParams = {} }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        authFetch({ apiMethod, endpoint, onDataLoaded, onErrorResponse, headers, body, queryParams })
            .catch((err) => setError(err.message))
            .finally(() => setLoading(false));
    }, [endpoint, apiMethod, onDataLoaded]);

    return null; // ✅ No UI rendering, just API calls
};
